import React, { useState, useEffect, useRef } from 'react'
import { string, array, func, oneOf, obj, number } from 'prop-types'
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton'
import arrow from '../../asset/icons/dropdown_arrow.svg'

const Select = props => {
  const { options, handleSelection, defaultValue, defaultId, placeholder: _placeholder, reset, index, customClassName } = props
  const [placeHeld, setPlaceHeld] = useState(false)
  const [placeholder, setPlaceholder] = useState(_placeholder)

  const generateOptions = () => {
    if (!options?.length) {
      return (<div>- no options -</div>)
    }
    return options.map((option, i) => {
      let content = option
      if (option.value) {
        content = option.value
      }
      return (
        <MenuItem key={`${content}-${i}`} value={option} className='lsn bgc-white fz15 br-1-s-green bdrs-4 df oh curp pt5 pr10 pb5 pl10'>
          {content}
        </MenuItem>
      )
    })
  }

  const createButtonClassName = customClassName => {
    return (customClassName && customClassName.buttonClassNames) || 'bgc-white bd2-s-input bdrs-4 h42 df aic jcsb pl10 pt10 pb10 pr15'
  } 

  const resetRef = useRef(false)
  useEffect(()=> {
    if(reset && reset !== resetRef.current){
      setPlaceholder(_placeholder)
      setPlaceHeld(false)
      resetRef.current = true
    }
  }, [
    _placeholder, placeHeld, reset
  ])

  const prevDefaultValue = useRef()
  const prevDefaultId = useRef()
  useEffect(() => {
    if(defaultValue){
      prevDefaultValue.current = defaultValue
      const newPlaceholder = options.find(option => {
        return option.value === defaultValue
      })
      setPlaceholder(newPlaceholder ? newPlaceholder.value : defaultValue)
      setPlaceHeld(true)
    } else if (defaultId){
      prevDefaultId.current = defaultId
      const newPlaceholder = options.find(option => {
        return option.id === defaultId
      })
      setPlaceholder(newPlaceholder ? newPlaceholder.value : defaultId)
      setPlaceHeld(true)
    } else {
      if(!defaultValue && prevDefaultValue.current?.length){
        setPlaceholder(_placeholder)
        setPlaceHeld(false)
      } else if (!defaultId && prevDefaultId.current?.length){
        setPlaceholder(_placeholder)
        setPlaceHeld(false)
      }
    }
  }, [
    defaultValue, defaultId, options, _placeholder
  ])

  const updatePlaceholder = (option, event) => {
    setPlaceHeld(true)
    handleSelection(option, event, index)
    setPlaceholder(option.value || option)
  }

  return (
    <Wrapper
      className='posr w100%'
      onSelection={updatePlaceholder}
    >
      <Button data-testid='selectButton' className={createButtonClassName(customClassName) +' '+ props.className} disabled={props.disabled}>
        <><span className={!placeHeld ? 'c-lightgray' : 'fz15'}>{placeholder}</span><img src={arrow} alt='' /></>
      </Button>
      <Menu className={`posa t0 w100% bgc-white bd1-s-lightgray bdrs-4 pt15 pb10 mah225 oys z1${options?.length ? '' : ' bgc-lightgray'}`}>
        {generateOptions()}
      </Menu>
    </Wrapper>
  )
}

export default Select

Select.propType = {
  defaultValue: oneOf([string, obj]),
  placeholder: string,
  options: array.isRequired,
  handleSelection: func,
  index: number
}
